<!--suppress JSUnresolvedReference -->
@if (luser | async; as user) {
  <div class="user-menu mx-2">
    <tui-hosted-dropdown [content]="umenu">
      <tui-avatar
        [rounded]="true"
        avatarUrl="{{ user.avatar }}"
        class="avatar-btn"
        size="s"
        text="{{ user.lastname }} {{ user.firstname }}"
      ></tui-avatar>
    </tui-hosted-dropdown>
  </div>

  <ng-template #umenu>
    <tui-data-list role="menu">
      <tui-opt-group>
        <a tuiOption class="profile-option" routerLink="/users/profile">
          <div class="d-flex align-items-center">
            <tui-avatar
              [rounded]="true"
              avatarUrl="{{ user.avatar }}"
              size="l"
              text="{{ user.lastname }} {{ user.firstname }}"
            ></tui-avatar>
            <div class="profile-info mx-3">
              <div class="profile-name">{{ user.lastname }} {{ user.firstname }}</div>
              <div class="profile-moto fw-light small" i18n>See your profile</div>
            </div>
          </div>
        </a>
      </tui-opt-group>
      <tui-opt-group>
        <a tuiOption class="m-option" (click)="logout()">
          <div class="d-flex align-items-center">
            <div class="m-option-icon">
              <tui-svg [src]="'tuiIconLogOutLarge'"></tui-svg>
            </div>
            <div class="m-option-text mx-3" i18n>Sign out</div>
          </div>
        </a>
      </tui-opt-group>
      <tui-opt-group>
        <div class="mini-links p-2 text-secondary">
          <a class="link-secondary" href="javascript:" i18n routerLink="/privacy-policy"
            >Privacy Policy</a
          >
          &nbsp; · &nbsp;
          <a class="link-secondary" href="javascript:" routerLink="/terms-of-service" i18n
            >Terms &amp; Conditions</a
          >
        </div>
      </tui-opt-group>
    </tui-data-list>
  </ng-template>
}
